import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'NavigateNext');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/NavigateNext.js
// module id = 4996
// module chunks = 2